<template>
    <div class="search">
          <main-panel>
            <template v-slot:header>
                <h2>{{$route.name}}</h2>
            </template>
        </main-panel>
        <section class="frame-padding">
            <div class="search__input">
                <input-ms placeholder="Поиск" class="" v-model="searchText" @click="getSearch($event,start,length)"></input-ms>
            </div>
            <div v-if="searchResult.length > 0" class="search__panel">
                <panel-ms v-for="item in searchResult" :key="item.id">
                    <router-link :to="item.link+(item.component_name == null?'/':'#') +item.url">
                        <h3 v-html="getSelected(item.header)"></h3>
                        <p v-html="getSelected(item.body)"></p>
                       <breadcrumb-ms :item-path="item.menu" :on-router="false"></breadcrumb-ms>
                    </router-link>
                </panel-ms>
            </div>
            <div v-if="searchResult.length > 0">
                <paginator-ms :count="count" :count-page="length" @change="paginatorChange" @increase-count="increaseCount"></paginator-ms>
            </div>
            <error-ms v-if="searchResult.length == 0"></error-ms>
        </section>
    </div>
</template>
<script>
import mainPanel from '../components/main/mainPanel.vue';
import inputMs from '../components/common/inputMs.vue';
import paginatorMs from '../components/common/paginatorMs.vue';
import panelMs from '../components/common/panelMs.vue';
import breadcrumbMs from '../components/common/breadcrumbMs.vue';
import errorMs from '../components/errorMs.vue';
import axios from 'axios';

export default{
    components:{
        mainPanel,
        inputMs,
        panelMs,
        paginatorMs,
        breadcrumbMs,
        errorMs
    },
    mounted(){
        this.getSearch('',this.start,this.length)
    },
    methods:{
        getSearch(text = '',start,length){
            if (text != ''){
                 this.$router.push({
                    query: {
                        text: text
                    }
                });
            }

            this.start = start
            this.length = length
            let searchStr = '&'
            searchStr += start>-1?'start='+start+'&':''
            searchStr +=length>-1?'end='+length+'&':''
            axios
                .get('https://mosp51.ru/api/search?searchText='+this.searchText+searchStr)
                .then(response=>{
                    if(response.data.length>1){
                        this.searchResult = response.data
                        this.count = response.data[0].count_doc
                        this.searchResult.map(e=>{
                            e.body = this.getBody(e.body,e.position,e.count) 
                        }) 
                    } 
                    
                })
        },
        paginatorChange(start){
            this.getSearch('',start,this.length)
        },
        increaseCount(length){
            this.getSearch('',this.start,length)
        },
        getSelected(text){
            return text
        },
        getBody(text,position,count){
            if (text == null){
                return null
            }
            let strat = ''
            let end = ''
            if (position > 70 ){
                strat = '...'
            } 
            if (count > 140 ){
                end = '...'
            } 
            console.log(text)
            let textArray =  text.split('|')
            for (let i = 0;i < textArray;i++){
                if (textArray[i].indexOf(this.searchText)){
                    return strat+textArray[i]+end
                }
            }
            return strat+textArray[0]+end
        }
    },
    data(){
        return {
            count:10,
            length:10,
            start:0,
            searchText:this.$route.query.text,
            searchResult:[]
        }
    }
}
</script>

<style>
.search .panel a,
.search .panel p,
.search .panel h3{
    font-size: 16px;
}
.search .panel a,
.search .panel p{
    margin-bottom: 8px;
}
.search .panel{
    width: 100%;
    padding: 32px;
}

.search .frame-padding .search__input{
    margin-bottom: 40px;
}
.search .frame-padding .search__panel{
    display: flex;
    flex-direction: column;
    gap: 40px;
}
.search  .search-ms___panel_input{
    width: 644px;
}
.search section{
    margin-bottom: 100px;
}
@media (max-width: 1000px){
    .search .search-ms___panel_input{
        width: 100%;
    }
    .search .panel a, 
    .search .panel p,
    .search .panel h3{
        font-size: 14px;
    }
    .search .breadcrumb-ms{
        display: flex;
    }
    .search .panel{
        padding: 16px;
    }
}
</style>